import styled from "styled-components";

import {
  getBorderRadius,
  getBorderWidth,
  getFontWeight,
  getSemanticColor,
  getSpacing,
} from "@braze/beacon-styling";

export const StyledTableContainer = styled.div`
  max-width: 100%;
  overflow-x: auto;
  scrollbar-color: ${getSemanticColor("neutral-background-medium")} transparent;

  table {
    border-collapse: separate;
    border-spacing: 1px;
    font-variant-numeric: tabular-nums;
    max-width: 100%;

    thead {
      border-bottom: solid ${getBorderWidth("thin")} ${getSemanticColor("neutral-border-decorative-medium")};
      margin-bottom: ${getSpacing("xs")};
      padding-bottom: ${getSpacing("xs")};
    }

    td,
    th {
      // The horizontal padding is set to lg/xl by default, but that is
      // overridden in the agentic chat interface when the chat interface is
      // not maximized.
      // Once we upgrade to styled-components v6, we can use container queries to
      // set the padding-right to sm when the chat interface is not maximized,
      // which would be more elegant.
      padding: 6px ${getSpacing("xl")} 6px ${getSpacing("lg")};
      transition: padding 0.2s ease-in-out;
      white-space: nowrap;
      box-shadow: 0 0 0 1px ${getSemanticColor("neutral-border-decorative-medium")};
    }

    td {
      background: ${getSemanticColor("neutral-background-default")};
    }

    th {
      background-color: ${getSemanticColor("neutral-background-weak")};
      font-weight: ${getFontWeight("bold")};
      // Override browser's default text-align for the table headers, which is center.
      text-align: initial;
    }

    // Applying border-radius to the table element itself does not work,
    // so we need to apply it to individual corner cells.
    & > :first-child > :first-child > :first-child {
      border-top-left-radius: ${getBorderRadius("inner")};
    }
    & > :first-child > :first-child > :last-child {
      border-top-right-radius: ${getBorderRadius("inner")};
    }
    & > :last-child > :last-child > :first-child {
      border-bottom-left-radius: ${getBorderRadius("inner")};
    }
    & > :last-child > :last-child > :last-child {
      border-bottom-right-radius: ${getBorderRadius("inner")};
    }
  }
`;
